import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import React, { useEffect } from 'react';
import { Translator } from '~domain/i18n/translator';
import { captureException } from '~frontend-common/helper/core/sentry';
import { errorToMessageId } from '~frontend-common/helper/error-to-message-id';
import { Box, BoxProps } from '~ui-kit/components/box/box';
import { Typography } from '~ui-kit/components/typography/typography';
import { theme } from '~ui-kit/theme';

interface SentryErrorBoxProps extends Pick<BoxProps, 'm' | 'mx' | 'my' | 'ml' | 'mr' | 'mt' | 'mb'> {
  error: unknown;
  translator: Translator;
  color?: string;
  // if messageOverride is provided, it will override the error's message
  messageOverride?: string;
}

// Renders an error message and capture the error with Sentry
export function SentryErrorBox({
  error,
  messageOverride,
  color = theme.colors.primaryLight,
  translator: { t },
  mb,
  mt,
  ...rest
}: SentryErrorBoxProps) {
  useEffect(() => {
    captureException(error);

    // Scroll at the top when an error occur
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box mb={mb || 2} mt={mt || 2} align="center" justify="center" flexDirection="column" width={['100%']} {...rest}>
      <Box alignItems="center" color={color}>
        <ErrorOutlineIcon style={{ fontSize: '20px' }} />
        <Typography $fontFamily="Montserrat" $fontWeight="normal" $fontSize="16px" $ml={[0, '10px']}>
          {messageOverride || t(errorToMessageId(error as Error))}
        </Typography>
      </Box>
    </Box>
  );
}
